import React from 'react';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';
import { policyTypes } from '@ourbranch/policy-types';

import { ExpandableCard } from 'core/components/expandable-card';
import { useStore } from 'core/store/store.mobx';
import { useDiscounts } from 'offer/hooks/use-discounts';
import { useDisabledState } from 'common/disabled-context';
import { MultilineDiscount } from './multiline-discount';
import { Discount } from './discount';
import { Paperless } from './paperless';
import { Inventory } from './inventory';
import { BranchPlusMultiPolicyDiscount } from './branch-plus-multi-policy-discount';
import { ConnectedHomeDiscount } from './connected-home-discount';
import { BundleDiscount } from './bundle-discount';
import { GoodStudent } from './good-student';
import { DrivingCourse } from './driving-course';
import { CommunityDrive } from './community-drive';
import { NewHomeDiscount } from './new-home-discount';
import { FutureEffectiveAdvancedQuote } from './future-effective-advanced-quote-savings';
import { FarmDiscount, FarmAssociationDiscount } from './farm-discount';

const DiscountToComponent = {
  paperless_savings: Paperless,
  imagery_collection_savings: Inventory,
  connected_home_discount_savings: ConnectedHomeDiscount,
  multi_policy_savings: BranchPlusMultiPolicyDiscount,
  bundle_savings: BundleDiscount,
  good_student: GoodStudent,
  driving_course: DrivingCourse,
  community_drive: CommunityDrive,
  new_home_savings: NewHomeDiscount,
  future_effective_date_savings: FutureEffectiveAdvancedQuote,
  legacy_savings: FarmDiscount,
  military_savings: FarmDiscount,
  education_savings: FarmDiscount,
  crop_insurance_savings: FarmDiscount,
  traditions_savings: FarmDiscount,
  association_savings: FarmAssociationDiscount
};

const DiscountsCard = observer(() => {
  const discounts = useDiscounts();

  const activeDiscounts = discounts.filter(({ isActive }) => isActive).length;
  const { offer: store } = useStore();
  const { disabled } = useDisabledState();
  const { values } = useFormikContext();
  const selectedOption = values?.selectedOption || store.selectedOption;
  const bundleCurrentlySelected = [policyTypes.ARBundle, policyTypes.HABundle, policyTypes.CABundle].includes(
    selectedOption
  );

  const showMultilineDiscountComponent = store.hardRejectionOnOffer && !bundleCurrentlySelected;

  return (
    <div id="offer_discounts">
      <ExpandableCard title="Discounts" badge={`${activeDiscounts} of ${discounts.length}`}>
        {discounts.map(
          ({ canEdit, label, isActive, amount, description, possibleSavings, appcuesId, id, htmlId }, ix) => {
            const Component = DiscountToComponent[id] || Discount;
            return (
              <Component
                key={ix}
                label={label}
                amount={amount}
                possibleSavings={possibleSavings}
                description={description}
                isActive={isActive}
                appcuesId={appcuesId}
                canEdit={canEdit}
                id={id}
                htmlId={htmlId}
                disabled={disabled}
              />
            );
          }
        )}
        {showMultilineDiscountComponent && <MultilineDiscount />}
      </ExpandableCard>
    </div>
  );
});

export default DiscountsCard;
